import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { DAYS_QTR, PAGE_SIZE } from '../../common/constants';
import { formatDate, formatDateSmall, formatTo0Decimal, formatTo1Decimal, isEmpty, isEmptyArray, isNullCheck } from '../../common/util.services';
import { exportSaleData, getPerformance, getPerfParam} from '../amazon.services';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup, useMediaQuery, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import '../amazon.scss';
import IButton from '../../../components/button/i-button.component';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import IReadOnlyField from '../../../components/text-component/readonly-field/i-readonlyfield.component';
import { Box, Tooltip } from '@mui/material';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';

const AmazonSalePerf = () => {
  const appContext = useContext(AppContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const rows: GridRowsProp = [];
  const [perfData, setPerfData] = useState(rows);
  dayjs.extend(utc);
  dayjs.extend(timezone);
  let today = dayjs();
  let sDate = today.subtract(DAYS_QTR, 'day');
  const [startDate, setStartDate] = useState<any>(sDate);
  const [endDate, setEndDate] = useState<any>(today);
  const [period, setPeriod] = useState('DailySale');
  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const [perfParam, setPerfParam] = useState<any>([])
  const columns: GridColDef[] = [
    { field: 'period', headerName: 'Period', filterable: false, sortable: false, editable: false, width: 125,
      renderCell: (params: any) =>  {return 'DailySale' === period ? formatDate(params.row.orderDate) : params.row.period},
      cellClassName: (params) => { return "Tacos2" }
    },
    { field: 'payout', headerName: 'Pay', filterable: false, sortable: false, editable: false, width: 65,
      renderCell: (params: any) =>  (<Tooltip title={'Daily: ' + getValue0Decimal(params.row.dailyPayout)}
      PopperProps={popperProps}>{<Box>{getValue0Decimal(params.row.payout)}</Box>}</Tooltip>),
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePerf(params.row.payout) }
    },
    { field: 'payoutPct', headerName: 'Pay/Sale', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
      cellClassName: (params) => { return getClassNamePerf(params.row.payout) }
    },
    { field: 'grossProfit', headerName: 'Gross', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePerf(params.row.grossProfit) }
    },
    { field: 'grossOnSale', headerName: 'Gross/Sale', filterable: false, sortable: false, editable: false, width: 90,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
      cellClassName: (params) => { return getClassNamePct(params.row.grossOnSale, params.row.saleReturn) }
    },
    { field: 'netProfit', headerName: 'Net', filterable: false, sortable: false, editable: false, width: 65,
      renderCell: (params: any) =>  (<Tooltip title={'Daily: ' + getValue0Decimal(params.row.dailyNet)}
      PopperProps={popperProps}>{<Box>{getValue0Decimal(params.row.netProfit)}</Box>}</Tooltip>),
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePerf(params.row.netProfit) }
    },
    { field: 'netOnSale', headerName: 'Net/Sale', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
      cellClassName: (params) => { return getClassNamePct(params.row.netOnSale, params.row.saleReturn) }
    },
    { field: 'netOnLfhCost', headerName: 'Net/LFH', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
      cellClassName: (params) => { return getClassNamePct(params.row.netOnLfhCost, params.row.saleReturn) }
    },
    { field: 'adSpendAdj', headerName: 'Ads', filterable: false, sortable: false, editable: false, width: 65,
      renderCell: (params: any) =>  (<Tooltip title={'Daily: ' + getValue0Decimal(params.row.dailyAd)}
      PopperProps={popperProps}>{<Box>{getValue0Decimal(params.row.adSpendAdj)}</Box>}</Tooltip>),
      valueFormatter: (value: any) => getValue0Decimal(value),
    },
    { field: 'tacos', headerName: 'TACOS', filterable: false, sortable: false, editable: false, width: 65,
      renderCell: (params: any) => (isEmpty(params.row.sale) ? 'NA' : 
                                    getValue1Decimal(params.row.adSpendAdj * 100/params.row.sale) + '%'),
      cellClassName: (params) => { return isEmpty(params.row.sale) ? '' : getClassNameTacos(params.row.adSpendAdj * 100/params.row.sale) }
    },
    { field: 'sale', headerName: 'Sale', filterable: false, sortable: false, editable: false, width: 65,
      renderCell: (params: any) =>  (<Tooltip title={'Daily: ' + getValue0Decimal(params.row.dailySale)}
      PopperProps={popperProps}>{<Box>{getValue0Decimal(params.row.sale)}</Box>}</Tooltip>),
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePerf(params.row.sale) }
    },
    { field: 'returnRate', headerName: 'Return', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => formatTo1Decimal(value * 100) + '%',
    },
    { field: 'saleReturn', headerName: 'Ret Sale', filterable: false, sortable: false, editable: false, width: 75,
      renderCell: (params: any) =>  (<Tooltip title={'Daily: ' + getValue0Decimal(params.row.dailyRetSale)}
      PopperProps={popperProps}>{<Box>{getValue0Decimal(params.row.saleReturn)}</Box>}</Tooltip>),
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePerf(params.row.saleReturn) }
    },
    { field: 'orderReturn', headerName: 'Ret Ord', filterable: false, sortable: false, editable: false, width: 75,
      renderCell: (params: any) =>  (<Tooltip title={'Daily: ' + getValue0Decimal(params.row.dailyRetOrd)}
      PopperProps={popperProps}>{<Box>{getValue0Decimal(params.row.orderReturn)}</Box>}</Tooltip>),
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePerf(params.row.orderReturn) }
    },
    { field: 'saleCount', headerName: 'Sale #', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'saleUnit', headerName: 'Total #', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'fulfillment', headerName: 'Fulfill', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => getValue0Decimal(value),
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.fulfillment, params.row.saleReturn)}
      PopperProps={popperProps}>{<Box>{formatTo0Decimal(params.row.fulfillment)}</Box>}</Tooltip>)
    },
    { field: 'referral', headerName: 'Refer', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => getValue0Decimal(value),
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.referral, params.row.saleReturn)}
      PopperProps={popperProps}>{<Box>{formatTo0Decimal(params.row.referral)}</Box>}</Tooltip>)
    },
    { field: 'storage', headerName: 'Store', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => getValue0Decimal(value),
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.storage, params.row.saleReturn)}
      PopperProps={popperProps}>{<Box>{formatTo0Decimal(params.row.storage)}</Box>}</Tooltip>)
    },
    { field: 'longStorage', headerName: 'Long Store', filterable: false, sortable: false, editable: false, width: 90,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'disposal', headerName: 'Dispose', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'invReimburse', headerName: 'Inv Reim', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'liquidation', headerName: 'Liquidate', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'returnFee', headerName: 'Ret Fee', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'awdStorage', headerName: 'AWD Store', filterable: false, sortable: false, editable: false, width: 90,
      valueFormatter: (value: any) => getValue0Decimal(value),
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.awdStorage, params.row.saleReturn)}
      PopperProps={popperProps}>{<Box>{formatTo0Decimal(params.row.awdStorage)}</Box>}</Tooltip>)
    },
    { field: 'awdProcessing', headerName: 'AWD Proc', filterable: false, sortable: false, editable: false, width: 85,
      valueFormatter: (value: any) => getValue0Decimal(value),
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.awdProcessing, params.row.saleReturn)}
      PopperProps={popperProps}>{<Box>{formatTo0Decimal(params.row.awdProcessing)}</Box>}</Tooltip>)
    },
    { field: 'awdTransportation', headerName: 'AWD Trn', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => getValue0Decimal(value),
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.awdTransportation, params.row.saleReturn)}
      PopperProps={popperProps}>{<Box>{formatTo0Decimal(params.row.awdTransportation)}</Box>}</Tooltip>)
    },
    { field: 'subscription', headerName: 'Subscribe', filterable: false, sortable: false, editable: false, width: 85,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'fbaInbound', headerName: 'FBA In', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'promotion', headerName: 'Promo', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => getValue0Decimal(value),
      renderCell: (params: any) =>  (<Tooltip title={getTooltipPromo(params.row)}
      PopperProps={popperProps}>{<Box>{formatTo0Decimal(params.row.promotion)}</Box>}</Tooltip>)
    },
    { field: 'adjustment', headerName: 'Adj', filterable: false, sortable: false, editable: false, width: 50,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'other', headerName: 'Other', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'totalFee', headerName: 'Total Fee', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'misc', headerName: 'Misc', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'lfhCost', headerName: 'LFH Cost', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'lfhAdj', headerName: 'LFH Adj', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'xneetiFee', headerName: 'Xneeti', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'otherGain', headerName: 'Oth Gain', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'totalFeePct', headerName: 'Total Fee', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'
    },
    { field: 'lfhCostPct', headerName: 'LFH Cost', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'
    },
    { field: 'adCostPct', headerName: 'Ad Cost', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'
    },
    { field: 'xneetiPct', headerName: 'Xneeti', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'
    },
    { field: 'totalCostPct', headerName: 'Total', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'
    }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getOrderData();
    getPerfParamData();
  }, [period, startDate, endDate, page, pageSize]);

  function getOrderData() {
    if (isEmptyArray(rows)) {
      setLoading(true);
      let data = {startDate: startDate, endDate: endDate, period: period};
      getPerformance(data, page, pageSize, appContext,
        (response: any) => {
          setPerfData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }

  function getClassNameTacos(value: any) {
    return value > 20 ? "PerfNegative" : "PerfPositive";
  }

  function getPerfParamData() {
    setLoading(true);
    let data = {startDate: startDate, endDate: endDate, period: 'TotalSale'};
    getPerfParam(data, appContext,
      (response: any) => {
        setPerfParam(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  };

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  function getTooltip(value: any, saleReturn: any) {
      return isNullCheck(saleReturn) ? '' : formatTo1Decimal(value * 100/saleReturn) + '% of return sale'
  }

  function calculateTacos(perfParam: any) {
    return isEmpty(perfParam.sale) ? '0.0%' : formatTo1Decimal(perfParam.adSpendAdj * 100/perfParam.sale) + '%'
  }

  function getTooltipPromo (row: any) {
    let saleReturn = row.saleReturn;
    let priceDiscount: any = formatTo0Decimal(row.priceDiscount);
    let priceDiscountPct = isNullCheck(saleReturn) ? 'NA' : formatTo1Decimal(priceDiscount * 100/saleReturn);
    let vine: any = formatTo0Decimal(row.vine);
    let vinePct = isNullCheck(saleReturn) ? 'NA' : formatTo1Decimal(vine * 100/saleReturn);
    let deal: any = formatTo0Decimal(row.deal);
    let dealPct = isNullCheck(saleReturn) ? 'NA' : formatTo1Decimal(deal * 100/saleReturn);
    let coupon: any = formatTo0Decimal(row.coupon);
    let couponPct = isNullCheck(saleReturn) ? 'NA' : formatTo1Decimal(coupon * 100/saleReturn);

    let text = priceDiscount + ',' + vine + ',' + deal + ',' + coupon;
    let array = text.split(',');
    array[0] = 'Price Discount: ' + array[0] + ('NA' === priceDiscountPct ? '' : ' (' + priceDiscountPct + '% of return sale)');
    array[1] = 'Vine: ' + array[1] + ('NA' === vinePct ? '' : ' (' + vinePct + '% of return sale)');
    array[2] = 'Deal: ' + array[2] + ('NA' === dealPct ? '' : ' (' + dealPct + '% of return sale)');
    array[3] = 'Coupon: ' + array[3] + ('NA' === couponPct ? '' : ' (' + couponPct + '% of return sale)');

    let newText = array.map(i => {
      return <p>{i}</p>
    });

    return newText;
  }

  function getClassNamePerf(value: any) {
    return isEmpty(value) ? '' : value <= 0 ? "PerfNegative" : "PerfPositive";
  }

  function getClassNamePct(value1: any, value2: any) {
    return isEmpty(value2) ? '' : value2 <= 0 || isEmpty(value1) || value1 <= 0 ? "PerfNegative" : "PerfPositive";
  }

  const getValue0Decimal = (value: any) => {
    return isEmpty(value) ? 'NA' : formatTo0Decimal(value * 1);
  }

  const getValue1Decimal = (value: any) => {
    return isEmpty(value) ? 'NA' : formatTo1Decimal(value * 1);
  }

  const search = (e: any) => {
    getOrderData();
  }

  const startDatechange = (value: any) => {
    setStartDate(value);
  }

  const endDatechange = (value: any) => {
    setEndDate(value);
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPeriod((event.target as HTMLInputElement).value);
  }

  const saveExcel = (invData: any) => {
    let header = ["Month", "Order", "Sale", "Fulfill", "% of Sale", "Refer", "% of Sale", "Storage", "% of Sale", 
                  "Other Fee", "% of Sale", "Total Fee", "% of Sale", "Misc", "% of Sale", "LFH Cost", "% of Sale", 
                  "Ads", "% of Sale", "Xneeti", "% of Sale", "Oth Gain", "% of Sale", "Net Profit", "% of Sale"];
    const excelSheet = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(excelSheet, [header]);
    XLSX.utils.sheet_add_json(excelSheet, invData, { origin: 'A2', skipHeader: true });
    const excelBook = { Sheets: { 'Sale': excelSheet }, SheetNames: ['Sale'] };
    const excelBuffer = XLSX.write(excelBook, { bookType: 'xlsx', type: 'array', cellStyles:true });
    const excelData = new Blob([excelBuffer], { type: 'xlsx' });
    FileSaver.saveAs(excelData, "Amazon_Monthly_Sale.xlsx");
  }

  const exportData = () => {
    exportSaleData(appContext,
      (response: any) => {
        saveExcel(response.data);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        setLoading(false);
      });
  }

  const getMainPanel = () => {
    return <>
      <Grid xs={2} sx={{ pl: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <FormControlLabel control={<LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <DatePicker slotProps={{ textField: { size: 'small' } }} format={'DD/MM/YYYY'}  
                                        label={'Start Date'} value={startDate} onChange={startDatechange} timezone="America/Los_Angeles"/>
                                  </LocalizationProvider>} label='' />
        <FormControlLabel control={<LocalizationProvider dateAdapter={AdapterDayjs}> 
                                      <DatePicker slotProps={{ textField: { size: 'small' } }} format={'DD/MM/YYYY'} 
                                        label={'End Date'} value={endDate} onChange={endDatechange} timezone="America/Los_Angeles"/>
                                  </LocalizationProvider>} label='' />
        <FormControl>
          <RadioGroup defaultValue="DailySale" name="period" row={true} onChange={handleChange}>
            <FormControlLabel value="DailySale" control={<Radio />} label="Daily" />
            <FormControlLabel value="WeeklySale" control={<Radio />} label="Weekly" />
            <FormControlLabel value="MonthlySale" control={<Radio />} label="Monthly" />
          </RadioGroup>
        </FormControl>
        <IButton label='Submit' onActionEvent={search}/>
        <IButton label='Export' color='secondary' onActionEvent={exportData} disabled={'MonthlySale' !== period}/>
      </Grid>
      <Grid xs={12} display="flex" justifyContent="center">
        <Grid container columnSpacing={1} rowSpacing={0} sx={{ maxWidth: '1380px', mt: 2, border: '1px solid #D3D3D3', borderRadius: '4px', p: 2}}>
          <Grid xs={2}>
            <IReadOnlyField label='Days' value={isEmpty(perfParam) ? 'NA' : perfParam.days}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Ads (Adj)' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.adSpendAdj)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Daily Ads' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.dailyAd)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Sale' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.sale)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Daily Sale' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.dailySale)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Sale #' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.saleCount)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Daily Sale #' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.dailySaleCount)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Total Unit #' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.saleUnit)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Daily Unit #' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.dailySaleUnit)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Net Profit' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.netProfit)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Daily Net' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.dailyNet)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Payout' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.payout)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Daily Payout' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.dailyPayout)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Payout/Sale' value={isEmpty(perfParam) ? 'NA' : formatTo1Decimal(perfParam.payoutPct) + '%'}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Gross/Sale' value={isEmpty(perfParam) ? 'NA' : formatTo1Decimal(perfParam.grossOnSale) + '%'}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Net/Sale' value={isEmpty(perfParam) ? 'NA' : formatTo1Decimal(perfParam.netOnSale) + '%'}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Net/LFH Cost' value={isEmpty(perfParam) ? 'NA' : formatTo1Decimal(perfParam.netOnLfhCost) + '%'}/>
          </Grid>
          <Grid xs={0.9}>
            <IReadOnlyField label='Ret' value={isEmpty(perfParam) ? 'NA' : formatTo1Decimal(perfParam.returnRate * 100) + '%'}/>
          </Grid>
          <Grid xs={0.9}>
            <IReadOnlyField label='TAC' value={calculateTacos(perfParam)}/>
          </Grid>
        </Grid>
      </Grid>
      <IGridComponent title={''} rows={perfData} columns={columns} loading={loading} maxHeight={450}
          paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
          showExtBtn={false} extBtnText={'Export'} extBtnAction={exportData}
          getRowId={(row: any) => row.idDate} showAction={false}/>
    </>
  }

  const getMobilePanel = () => {
    const mobileColumns: GridColDef[] = [
      { field: 'period', headerName: 'Date', filterable: false, sortable: false, editable: false, width: 70, disableColumnMenu: true,
        renderCell: (params: any) =>  {return formatDateSmall(params.row.orderDate)},
        cellClassName: (params) => { return "Tacos2" } },
      { field: 'sale', headerName: 'Sale', filterable: false, sortable: false, editable: false, width: 65, disableColumnMenu: true,
        valueFormatter: (value: any) => getValue0Decimal(value),
        cellClassName: (params) => { return getClassNamePerf(params.row.sale) }},
      { field: 'returnRate', headerName: 'Ret', filterable: false, sortable: false, editable: false, width: 55, disableColumnMenu: true,
        valueFormatter: (value: any) => formatTo0Decimal(value * 100) + '%'},
      { field: 'saleReturn', headerName: 'R-Sale', filterable: false, sortable: false, editable: false, width: 65, disableColumnMenu: true,
        valueFormatter: (value: any) => getValue0Decimal(value),
        cellClassName: (params) => { return getClassNamePerf(params.row.saleReturn) }},
      { field: 'netProfit', headerName: 'Net', filterable: false, sortable: false, editable: false, width: 55, disableColumnMenu: true,
        valueFormatter: (value: any) => getValue0Decimal(value),
        cellClassName: (params) => { return getClassNamePerf(params.row.netProfit) }},
    ];
    return <>
    <Box sx={{ fontSize: '20px', fontWeight: 'bold', color: 'darkblue' }}>DAILY SALE</Box>
    <IGridComponent title={''} rows={perfData} columns={mobileColumns} loading={loading} maxHeight={450}
      getRowId={(row: any) => row.idDate} showAction={false} hideFooter={true} />
    </>
  }

  return !isMobile ? <TitlePanel title={(period.includes('Monthly') ? 'Monthly' : period.includes('Daily') ? 'Daily' : 'Weekly') + ' Sale'} 
          panelBody={getMainPanel()} /> : getMobilePanel();
}

export default AmazonSalePerf;